import { IFilterKeys, IFilters } from 'models/core';
import { extractFilterLabel } from 'models/mdt';
import { PlotData } from 'plotly.js';

export function DataToCSV(traces: Partial<PlotData>[], 
                          chartType: string, 
                          chartOrientation: string, 
                          labelTitle: string, 
                          valueTitle: string, 
                          chartTitle: string,
                          currentFilters: IFilters<IFilterKeys>,
                          ): string {
  

  let chartTraces = new Set;
  traces?.forEach(a => chartTraces.add(a.name))


  //transform the traces into one array 
  let labs: any[] = [];
    //Get unique labels. 
    //Create the array of labels using either the x or y values if chart is vertical or horizontal respectively 
    //Replace any commas (,) in the label with dash (-)

    if (chartType == "pie") {
      traces.forEach(a => {
        a.labels.forEach((p: any) => {
          if (labs.indexOf(p) === -1) {
            labs.push(p.replaceAll(`,`, `- `))
          }
        })
      })
    } else if (chartOrientation == "v") {
      traces.forEach(a => {
        a.x.forEach((p) => {
          if (labs.indexOf(p) === -1) {
            labs.push(p.replaceAll(`,`, `- `))
          }
        })
      })
    } else {
      traces.forEach(a => {
        a.y.forEach(p => {
          if (labs.indexOf(p) === -1) {
            labs.push(p.replaceAll(`,`, `- `))
          }
        })
      })
    }

    //Reverse array when horizontal 
    if (chartOrientation == "h") { 
      labs.reverse();
    }

    //Get Values. Push an array of values for each trace to create an array of arrays
    //Ensure that the correct value is pushed for each label by using the index of the label
    //Where available use the 'text' property from the traces as this has additional formatting like %, thousands separator etc 
    let vals = Array.from(Array(chartTraces.size), () => new Array(labs.length));

    for (i=0; i<chartTraces.size; i++) {
     if (chartType == "pie") {
      for (var a=0; a<labs.length; a++) {
        vals[i][a] = traces[i].values[traces[i].labels.indexOf((labs[a].replaceAll(`- `,`,`)))];
      }
     } else if (chartOrientation == "v") {
        for (var a=0; a<labs.length; a++) {
          let textArray: string[] = (traces[i].text as string[] ? traces[i].text as string[] : traces[i].y as string[]);
          vals[i][a] = textArray[traces[i].x.indexOf((labs[a].replaceAll(`- `,`,`)))];
        }
      } else {
            for (var a=0; a<labs.length; a++) {
              let textArray: string[] = (traces[i].text as string[] ? traces[i].text as string[] : traces[i].x as string[]);
                vals[i][a] = textArray[traces[i].y.indexOf((labs[a].replaceAll(`- `, `,`)))]
        }
      }
    }

    //Add header to each array 
    // x axis label to the labs -either the labelTitle or the chart title if not given
    labs.unshift(labelTitle || chartTitle);
    
    // Trace name(s) for vals 
    if (chartTraces.size == 1) {
      vals[0].unshift(valueTitle as any);
    } else {
        for (i=0; i < chartTraces.size; i++) {
            vals[i].unshift(traces[i].name);
          }
      }

    //Combine values and labels into one array of arrays 
    let combinedTraces: any[] = Array.from(Array(labs.length), () => new Array(chartTraces.size + 1));
    for (var i=0; i < labs.length; i++)  {
        combinedTraces[i][0] = labs[i];
        for (var x=1; x < chartTraces.size+1; x++) {
          combinedTraces[i][x] = vals[x-1][i];
        }
      }
    
    //get list of filters 
    let filterLabel: any =  "" 
    if (extractFilterLabel(currentFilters, "  ") !== "") { 
        combinedTraces.push(["", ""]);
        combinedTraces.push(["Selected Filters", ""]);
        filterLabel = extractFilterLabel(currentFilters, " | ");
    }
    combinedTraces.push([filterLabel.replaceAll(`,`, `- `), ""]);

    //Add source and timestamp to the bottom of the array
    const source = "Source: Cancer Alliance Queensland (" + window.location.href + ")"
    const timeStamp = "Downloaded: " + new Date().toString();
    combinedTraces.push(["", ""]); 
    combinedTraces.push([source, ""]);
    combinedTraces.push([timeStamp, ""]);
        
    return (
        combinedTraces.map(row =>
            row
            .map(String)  // convert every value to String
            .map((v: { replaceAll: (arg0: string, arg1: string) => any; }) => v.replaceAll('"', '""'))  // escape double colons
            .map((v: any) => `"${v}"`)  // quote it
            .map((v: any) => "=" + v) //add an equals sign before every argument
            .join(',')  // comma-separated
            ).join('\r\n')
    );
}